export const IDLE_STREAM_HEALTH = {
    severity: 'idle',
    issues: [],
    bitrateKbps: null,
    rttMs: null,
    packetLossPct: null,
    connectedPeers: 0,
    remoteIssueCount: 0,
    remoteIssues: [],
};
const ISSUE_RANK = {
    disconnected: 70,
    'no-video': 60,
    'frozen-video': 50,
    'no-audio': 40,
    'packet-loss': 30,
    'low-bandwidth': 20,
    'high-rtt': 10,
};
export function primaryStreamHealthIssue(issues) {
    let best = null;
    let rank = -1;
    for (const issue of issues) {
        const next = ISSUE_RANK[issue];
        if (next > rank) {
            best = issue;
            rank = next;
        }
    }
    return best;
}
export function severityFromIssues(issues) {
    if (issues.length === 0) {
        return 'ok';
    }
    if (issues.includes('disconnected') ||
        issues.includes('no-video') ||
        issues.includes('frozen-video') ||
        ((issues.includes('packet-loss') || issues.includes('low-bandwidth')) && issues.includes('no-audio'))) {
        return 'bad';
    }
    return 'warn';
}
export function classifyStreamHealth(input) {
    const issues = [];
    if (input.connectionFailed) {
        issues.push('disconnected');
    }
    if (!input.warmupDone) {
        return { severity: severityFromIssues(issues), issues };
    }
    const videoBitrate = input.videoBitrateKbps ?? 0;
    const fps = input.videoFps ?? 0;
    if (input.side === 'publisher') {
        if (!input.hasExpectedVideo) {
            issues.push('no-video');
        }
        else if (input.connectedPeers > 0 &&
            input.videoBitrateKbps !== null &&
            input.videoBitrateKbps < 80) {
            issues.push('low-bandwidth');
        }
        if (!input.hasExpectedAudio) {
            issues.push('no-audio');
        }
    }
    else if (input.hasExpectedVideo && input.videoBitrateKbps !== null) {
        if (fps < 1 && videoBitrate < 50) {
            issues.push('no-video');
        }
        else if (fps < 4 && videoBitrate >= 50) {
            issues.push('frozen-video');
        }
        else if (videoBitrate > 0 && videoBitrate < 150) {
            issues.push('low-bandwidth');
        }
    }
    if (input.side === 'subscriber' &&
        input.hasExpectedAudio &&
        input.audioBitrateKbps !== null &&
        input.audioBitrateKbps < 4) {
        issues.push('no-audio');
    }
    if ((input.packetLossPct ?? 0) >= 8) {
        issues.push('packet-loss');
    }
    if ((input.rttMs ?? 0) >= 400) {
        issues.push('high-rtt');
    }
    return { severity: severityFromIssues(issues), issues };
}
export function uniqueHealthIssues(issues) {
    const seen = new Set();
    const result = [];
    for (const issue of issues) {
        if (!seen.has(issue)) {
            seen.add(issue);
            result.push(issue);
        }
    }
    return result;
}
export function mergeStreamHealth(local, remoteIssues, remoteIssueCount) {
    const mergedIssues = uniqueHealthIssues([...local.issues, ...remoteIssues]);
    let severity = severityFromIssues(mergedIssues);
    if (mergedIssues.length === 0) {
        severity = local.connectedPeers > 0 ? 'ok' : 'idle';
    }
    return {
        ...local,
        issues: mergedIssues,
        severity,
        remoteIssues: uniqueHealthIssues(remoteIssues),
        remoteIssueCount,
    };
}
//# sourceMappingURL=health.js.map